import { Container, CheckRead } from './styled';
import { BiTime, BiCheck, BiCheckDouble } from 'react-icons/bi';

export function StatusMessage(props) {

  const { message } = props;
  
  return (
    <Container>
      {message?.read_datetime
        ? <CheckRead>
          <BiCheckDouble className='icon-size' />
        </CheckRead>
        : <>
          {message?.delivered_datetime
            ? <BiCheckDouble className='icon-size' />
            : <>
              {message?.sent_datetime
                ? <BiCheck className='icon-size' />
                : <BiTime className='icon-size' />
              }
            </>
          }
        </>
      }
    </Container>
  );
}